import '../styles/Modaliser.css';

import React from 'react';
import { styled } from '@mui/system';

const StyledDiv = styled('div')(({ theme }) => ({
  position: 'relative',
  zIndex: 1299, //* 1300: Select menu popover
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius
}));

interface ModaliserProps {
  children: JSX.Element;
}

const Modaliser = (props: ModaliserProps) => {
  return (
    <>
      <div className="modaliser"></div>
      <StyledDiv>{props.children}</StyledDiv>
    </>
  );
};

export default Modaliser;
